import { LockPosition } from "../../../../../types/routeBuilder";

export type EdgeLockPosition = Exclude<LockPosition, null>;

export function clampToUnlockedRange(
  visits: ReadonlyArray<{ lock: LockPosition }>,
  toIndex: number,
) {
  let firstUnlockedIndex = 0;
  while (visits[firstUnlockedIndex]?.lock === "start") {
    firstUnlockedIndex += 1;
  }

  let lastUnlockedIndex = visits.length;
  while (visits[lastUnlockedIndex - 1]?.lock === "end") {
    lastUnlockedIndex -= 1;
  }

  return Math.max(firstUnlockedIndex, Math.min(toIndex, lastUnlockedIndex));
}

/**
 * Return the edge lock this stop may toggle, or null when changing it would
 * create a non-contiguous lock block in the middle of the route.
 */
export function getLockControlPosition(
  locks: LockPosition[],
  index: number,
): EdgeLockPosition | null {
  const lock = locks[index];
  if (lock === undefined) return null;

  if (lock === "start") {
    return locks[index + 1] === "start" ? null : "start";
  }
  if (lock === "end") {
    return locks[index - 1] === "end" ? null : "end";
  }

  const nextStartIndex = locks.findIndex((value) => value !== "start");
  if (index === nextStartIndex) return "start";

  let nextEndIndex = locks.length - 1;
  while (nextEndIndex >= 0 && locks[nextEndIndex] === "end") {
    nextEndIndex -= 1;
  }
  return index === nextEndIndex ? "end" : null;
}
